module.exports = __webpack_public_path__ + "static/media/nonord-c-15.2cb59b24.mp3";